<div class="flex flex-col border-b group hover:bg-ponder-linkhover hover:bg-opacity-10" [ngClass]="{ 'bg-ponder-linkhover bg-opacity-10' : deckTotal.total}">
    <a href="{{ deckRoute }}">
        <div #titleOuter class="text-faded-90 stroke-faded-90 hover:text-white hover:stroke-white hover:font-bold shadow">
            <div #titleInner class="flex flex-row items-center gap-2 p-2">
                @if (deckTotal.deck.isFavorited) {
                    <svg class="size-4 fill-faded-70" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1">
                        <title>Favorite</title>
                        <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="starSvgIcon" />
                    </svg>
                }
                <div class="grow">
                    {{ deckTotal.deck.deckName }}
                </div>
                @if (deckTotal.total) {
                    <div>
                        <svg class="w-5 h-5 fill-none opacity-70" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5">
                            <title>Close</title>
                            <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="inDeckSvgIcon" />
                        </svg>
                    </div>
                }
            </div>
        </div>
    </a>
    <div class="p-2 grid grid-cols-3">
        @if (hasNormal) {
            <!-- Mainboard - Normal -->
            <div class="flex flex-row gap-1 items-center align-middle justify-center">
                <div (click)="adjustCount(-1, 0, 0, 0, 0, 0)" class="w-6 h-6 cursor-pointer hover:bg-gray-200 hover:bg-opacity-10 flex justify-center items-center">
                    –
                </div>
                <div>
                    <input type="text" class="p-1 w-[3ch] text-center bg-transparent" [attr.value]="deckTotal.deck.mainboardCount" [ngClass]="{ 'font-bold' : deckTotal.deck.mainboardCount }">
                </div>
                <div (click)="adjustCount(1, 0, 0, 0, 0, 0)" class="w-6 h-6 cursor-pointer hover:bg-gray-200 hover:bg-opacity-10 flex justify-center items-center">
                    +
                </div>
            </div>
            <!-- Sideboard - Normal -->
            <div class="flex flex-row gap-1 items-center align-middle justify-center">
                <div (click)="adjustCount(0, -1, 0, 0, 0, 0)" class="w-6 h-6 cursor-pointer hover:bg-gray-200 hover:bg-opacity-10 flex justify-center items-center">
                    –
                </div>
                <div>
                    <input type="text" class="p-1 w-[3ch] text-center bg-transparent" [attr.value]="deckTotal.deck.sideboardCount" [ngClass]="{ 'font-bold' : deckTotal.deck.sideboardCount }">
                </div>
                <div (click)="adjustCount(0, 1, 0, 0, 0, 0)" class="w-6 h-6 cursor-pointer hover:bg-gray-200 hover:bg-opacity-10 flex justify-center items-center">
                    +
                </div>
            </div>
            <!-- Maybeboard - Normal -->
            <div class="flex flex-row gap-1 items-center align-middle justify-center">
                <div (click)="adjustCount(0, 0, -1, 0, 0, 0)" class="w-6 h-6 cursor-pointer hover:bg-gray-200 hover:bg-opacity-10 flex justify-center items-center">
                    –
                </div>
                <div>
                    <input type="text" class="p-1 w-[3ch] text-center bg-transparent" [attr.value]="deckTotal.deck.maybeboardCount" [ngClass]="{ 'font-bold' : deckTotal.deck.maybeboardCount }">
                </div>
                <div (click)="adjustCount(0, 0, 1, 0, 0, 0)" class="w-6 h-6 cursor-pointer hover:bg-gray-200 hover:bg-opacity-10 flex justify-center items-center">
                    +
                </div>
            </div>
        }
        @if (hasSpecial) {
            <!-- Mainboard - Foil -->
            <div class="flex flex-row gap-1 items-center align-middle justify-center">
                <div (click)="adjustCount(0, 0, 0, -1, 0, 0)" class="w-6 h-6 cursor-pointer hover:bg-gray-200 hover:bg-opacity-10 flex justify-center items-center">
                    –
                </div>
                <div>
                    <input type="text" class="p-1 w-[3ch] text-center bg-transparent text-foil-dark" [attr.value]="deckTotal.deck.mainboardSpecialCount" [ngClass]="{ 'font-bold' : deckTotal.deck.mainboardSpecialCount }">
                </div>
                <div (click)="adjustCount(0, 0, 0, 1, 0, 0)" class="w-6 h-6 cursor-pointer hover:bg-gray-200 hover:bg-opacity-10 flex justify-center items-center">
                    +
                </div>
            </div>
            <!-- Sideboard - Foil -->
            <div class="flex flex-row gap-1 items-center align-middle justify-center text-center">
                <div (click)="adjustCount(0, 0, 0, 0, -1, 0)" class="w-6 h-6 cursor-pointer hover:bg-gray-200 hover:bg-opacity-10 flex justify-center items-center">
                    –
                </div>
                <div>
                    <input type="text" class="w-[3ch] text-center bg-transparent text-foil-dark" [attr.value]="deckTotal.deck.sideboardSpecialCount" [ngClass]="{ 'font-bold' : deckTotal.deck.sideboardSpecialCount }">
                </div>
                <div (click)="adjustCount(0, 0, 0, 0, 1, 0)" class="w-6 h-6 cursor-pointer hover:bg-gray-200 hover:bg-opacity-10 flex justify-center items-center">
                    +
                </div>
            </div>
            <!-- Maybeboard - Foil -->
            <div class="flex flex-row gap-1 items-center align-middle justify-center">
                <div (click)="adjustCount(0, 0, 0, 0, 0, -1)" class="w-6 h-6 cursor-pointer hover:bg-gray-200 hover:bg-opacity-10 flex justify-center items-center">
                    –
                </div>
                <div>
                    <input type="text" class="p-1 w-[3ch] text-center bg-transparent text-foil-dark" [attr.value]="deckTotal.deck.maybeboardSpecialCount" [ngClass]="{ 'font-bold' : deckTotal.deck.maybeboardSpecialCount }">
                </div>
                <div (click)="adjustCount(0, 0, 0, 0, 0, 1)" class="w-6 h-6 cursor-pointer hover:bg-gray-200 hover:bg-opacity-10 flex justify-center items-center">
                    +
                </div>
            </div>
        }
    </div>
</div>